import React, { useState, useEffect } from "react";
import HeatmapTable, { G, O, R } from "./HeatmapTable";
import Loading from "../../../../common-components/Loading";
import { getHeatmapCurrentMonthAPI } from "../../../../api/reports-api";

const COLS = [
  { key: "cmRevActuals", label: "Curr Month\nRevenue Actuals", w: 150, isCurrency: true  },
  { key: "cmRevBudget",  label: "Curr Month\nRevenue Budget",  w: 150, isCurrency: true  },
  { key: "cmGmActuals",  label: "Curr Month\nGM Actuals",      w: 130, isCurrency: true  },
  { key: "cmGmBudget",   label: "Curr Month\nGM Budget",       w: 130, isCurrency: true  },
  { key: "vacantFTEs",   label: "Vacant FTEs",                 w: 90,  isCurrency: false },
];

const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function hexToStatus(hex) {
  if (!hex) return null;
  if (hex === "#ff0000") return R;
  if (hex === "#ffff00") return O;
  return G;
}

function mapRow(r) {
  return {
    id:           r.contractId,
    projectName:  r.projectName,
    pm:           r.programManager,
    cmRevActuals: r.contractRevenue,
    cmRevBudget:  r.contractRevenueBudget,
    cmGmActuals:  r.grossMargin,
    cmGmBudget:   r.grossMarginBudget,
    vacantFTEs:   r.vacantFte,
    financial:    hexToStatus(r.financial),
    performer:    hexToStatus(r.perform),
    funding:      hexToStatus(r.funding),
    staffing:     hexToStatus(r.staffing),
    culture:      hexToStatus(r.culture),
    customer:     hexToStatus(r.customer),
    doge:         hexToStatus(r.doge),
  };
}

function mapTotal(t) {
  return {
    cmRevActuals: t.contractRevenue,
    cmRevBudget:  t.contractRevenueBudget,
    cmGmActuals:  t.grossMargin,
    cmGmBudget:   t.grossMarginBudget,
    vacantFTEs:   t.vacantFte,
    financial: null, performer: null, funding: null,
    staffing:  null, culture:   null, customer: null, doge: null,
  };
}

export default function CurrentMonthHeatmap({ filters, onMeta }) {
  const [loading,  setLoading]  = useState(true);
  const [rows,     setRows]     = useState([]);
  const [totalRow, setTotalRow] = useState(null);
  const [title,    setTitle]    = useState("Current Month Heatmap");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getHeatmapCurrentMonthAPI(filters)
      .then((res) => {
        if (cancelled) return;
        const d = res?.data;
        if (d) {
          setRows((d.rows || []).map(mapRow));
          setTotalRow(mapTotal(d.totals || {}));
          const mo = d.actualThroughMonth > 0 ? MONTHS[d.actualThroughMonth - 1] : "";
          setTitle(`Current Month Heatmap — ${mo} ${d.fiscalYear}`);
          onMeta?.({ actualThroughMonth: d.actualThroughMonth, fiscalYear: d.fiscalYear });
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <Loading />;
  return <HeatmapTable title={title} cols={COLS} totalRow={totalRow} rows={rows} />;
}
